import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import TextField from "@material-ui/core/TextField";
import Modal from "@material-ui/core/Modal";

const InformedConsentModal = ({ openModalCreate, closeModal, onSave }) => {
  const [titleConsent, setTitleConsent] = useState(null);

  const handleSave = () => {
    if (titleConsent !== null && titleConsent !== undefined) {
      onSave(titleConsent);
      closeModal()
      setTitleConsent("")
    }
  };

  return (
    <>
      <Modal
        open={openModalCreate}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
      >
        <div
          className="paperAppointment-flex"
          style={{ width: "30%", margin: 5 }}
        >
          <div className="subtitle-mod">
            <h4>Consentimiento informado</h4>
          </div>

          <TextField
            required
            style={{ marginTop: 10, width: "100%" }}
            className="title-consent-field"
            id="title-consent-required"
            label="Titulo del consentimiento informado"
            type="text"
            value={titleConsent}
            onChange={(e) => {
              setTitleConsent(e.target.value);
            }}
            InputLabelProps={{
              style: { color: "#646777" },
            }}
          />
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: 20 }}
              onClick={closeModal}
            >
              Cerrar
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: 20 }}
              onClick={handleSave}
            >
              Guardar
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default InformedConsentModal;
